'use es6';

import I18n from 'I18n';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { FormErrors, parseFormError } from 'FormsUI/api/Forms';
import * as FormsService from 'FormsUI/api/Forms';
import * as LeadFlowsService from 'FormsUI/api/LeadFlows';
import { hasBusinessUnitAccess as getHasBusinessUnitAccess } from 'FormsUI/selectors/Scope';
import getCloningErrorMessageKey from 'FormsUI/utils/translation/getCloningErrorMessageKey';
import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
import { SUCCEED_CLONING_FORM, FAIL_CLONING_FORM, REQUEST_FORM_CLONING } from './formCloningActions';
export const succeedCloningForm = () => ({
  type: SUCCEED_CLONING_FORM,
  meta: {
    notification: {
      type: 'success',
      title: I18n.text('formCloning.successHeading'),
      message: I18n.text('formCloning.successDescription')
    }
  }
});
export const failCloningForm = (reason = FormErrors.UNKNOWN) => ({
  type: FAIL_CLONING_FORM,
  reason,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('formCloning.failureHeading'),
      message: I18n.text(getCloningErrorMessageKey('formCloning', reason))
    }
  }
});
export const requestCloningForm = () => ({
  type: REQUEST_FORM_CLONING
});
export const cloneForm = ({
  guid,
  name,
  formType,
  businessUnitId
}) => (dispatch, getState) => {
  dispatch(requestCloningForm());
  const state = getState();
  const hasBusinessUnitAccess = getHasBusinessUnitAccess(state);
  const businessUnitIdForClone = hasBusinessUnitAccess ? businessUnitId : ACCOUNT_BUSINESS_UNIT_ID;
  let cloneFormRequest = null;
  switch (formType) {
    case FormTypes.FLOW:
      cloneFormRequest = LeadFlowsService.cloneForm;
      break;
    default:
      cloneFormRequest = FormsService.cloneForm;
  }
  return cloneFormRequest({
    guid,
    name,
    businessUnitId: businessUnitIdForClone
  }).then(newForm => {
    dispatch(succeedCloningForm());
    return newForm;
  }, err => {
    switch (err.xhr.status) {
      case 0:
        dispatch(failCloningForm(FormErrors.NO_NETWORK));
        break;
      case 404:
        dispatch(failCloningForm(FormErrors.NOT_FOUND));
        break;
      case 409:
        dispatch(failCloningForm(FormErrors.DUPLICATE_NAME));
        break;
      default:
        dispatch(failCloningForm(parseFormError(err.xhr)));
    }
    return Promise.reject(err);
  });
};
export default cloneForm;